import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(pageNo, data) {
    let params = "";
    if (data) {
      Object.keys(data).forEach((key) => {
        if (data[key] !== null && data[key] !== undefined && data[key] !== "") {
          params += `${key}=${data[key]}&`;
        }
      });
    }
    return api.get(`/api/Form/${pageNo}?${params}`);
  },
  create(data) {
    return api.post(`/api/Form`, data);
  },
  getById(id) {
    return api.get(`/api/Form/byId/${id}`);
  },
  update(id, data) {
    return api.put(`/api/Form/${id}`, data);
  },
  delete(id) {
    return api.delete(`/api/Form/${id}`);
  },
};
